import Vue from 'vue'
import { View, IPanelLayout, IPanel } from '@/types/view'

import Toolbox from './Toolbox.vue'

// Import API
//
// Untuk interaksi dengan backend
import { Get, Patch } from '@/api/view'

// Toolbar component
import Toolbar from './toolbar.vue'

import PropertiesWrapper from './properties-wrapper.vue'
import ViewProperties from './properties.vue'

import 'splitpanes/dist/splitpanes.css'

const { Splitpanes, Pane } = require('splitpanes')

const { GridLayout, GridItem } = require('vue-grid-layout')

// const bps = { lg: '1201px', md: '997px', sm: '769px', xs: '481px', xxs: '1px' }

export default Vue.extend({
  name: 'ViewEditor',
  components: {
    GridLayout,
    GridItem,
    Toolbar,
    Toolbox,
    PropertiesWrapper,
    ViewProperties,
    Splitpanes,
    Pane,
  },
  data() {
    return {
      view: {
        id: 0,
        uid: '',
        title: '',
        slug: '',
        icon: '',
        url: '',
        attributes: {},
        panels: [],
        version: 0,
        groupId: 0,
        orderIndex: 0,
      } as View,
      indexOfSelectedPanel: -1,
      viewId: -1,
      currentBp: 'lg',
      rangeWidth: '',
      layoutBreakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
      layoutCols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
      layoutColNum: 12,
    }
  },

  computed: {
    layouts(): IPanelLayout[] {
      return this.view.panels.map((panel) => panel.layout)
    },
  },

  methods: {
    // ---------------------------------------------------------------------------------------------------------
    // Interaksi dengan database & backend
    // ---------------------------------------------------------------------------------------------------------

    /** Ambil data view dari server berdasarkan id. */
    async get() {
      this.view = await Get(this.viewId)

      // get breakpoints
      if (this.view.attributes.breakpoints !== undefined) {
        this.layoutBreakpoints = this.view.attributes.breakpoints
      } else {
        this.layoutBreakpoints = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }
      }

      // get cols
      if (this.view.attributes.cols !== undefined) {
        this.layoutCols = this.view.attributes.cols
      } else {
        this.layoutCols = { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }
      }

      if (this.view.panels) {
        for (const i in this.view.panels) {
          this.view.panels[i].attributes = this.view.panels[i].attributes || {}
        }
      }

      this.breakpoints(this.currentBp)
      this.updateBreadCrumb()
    },

    /** Path view. */
    async patch(id: number, v: View) {
      await Patch(id, v)
    },

    // ---------------------------------------------------------------------------------------------------------
    // Commons
    // ---------------------------------------------------------------------------------------------------------
    duplictePanel(index: number) {
      if (index == -1) return

      const srcPanel: IPanel = JSON.parse(
        JSON.stringify(this.view.panels[index])
      )
      srcPanel.layout.i = new Date().getTime().toString()

      this.view.panels.push(srcPanel)
    },
    deletePanel(index: number) {
      if (index == -1) return

      this.view.panels.splice(index, 1)
      this.indexOfSelectedPanel = -1
    },
    // ---------------------------------------------------------------------------------------------------------
    // Toolbars
    // ---------------------------------------------------------------------------------------------------------

    /** Ketika toolbar save di klik perubahan ke database kemudian perbarui data yang ditampilkan.     */
    async onToolbarSave() {
      await this.patch(this.viewId, this.view)
      await this.get()
    },

    /** Ketika toolbar refresh di klik, ambil data view. */
    async onToolbarRefresh() {
      await this.get()
    },

    async onToolbarDuplicate() {
      this.duplictePanel(this.indexOfSelectedPanel)
    },

    /**
     * Menghapus panel berdasarkan index yang dipilih.
     *
     * Panelnya harus diklik dahulu untuk bisa dihapus.
     */
    onToolbarDelete() {
      this.deletePanel(this.indexOfSelectedPanel)
    },

    // ---------------------------------------------------------------------------------------------------------
    // Event pada mouse & keyboard
    // ---------------------------------------------------------------------------------------------------------
    // eslint-disable-next-line
    onKeyboardPress(event: any) {
      // console.log(event.key)
      if (this.indexOfSelectedPanel == -1) return
      const panel = this.view.panels[this.indexOfSelectedPanel]
      switch (event.key) {
        case 'Delete':
          this.deletePanel(this.indexOfSelectedPanel)
          break
        case 'ArrowLeft':
          panel.layout.x--
          // Left pressed
          break
        case 'ArrowRight':
          panel.layout.x++
          // Right pressed
          break
        case 'ArrowUp':
          panel.layout.y--
          // Up pressed
          break
        case 'ArrowDown':
          panel.layout.y++
          // Down pressed
          break
      }
    },

    onPanelRightClick() {
      //
    },

    onPanelClick(index: number) {
      this.indexOfSelectedPanel = index
    },

    onPanelKeyUpDelete(index: number) {
      console.log('Delete')

      this.deletePanel(index)
    },

    // ------------------------------
    //
    // DRAG AND DROP
    //
    // ------------------------------

    // eslint-disable-next-line
    handleDragover($event: any) {
      // eslint-disable-next-line
      ;(this as any).$refs.dropArea.style.display = 'block'
    },

    // eslint-disable-next-line
    handleDragEnd() {
      // eslint-disable-next-line
      ;(this as any).$refs.dropArea.style.display = 'none'
    },

    // eslint-disable-next-line
    handleDrop($event: any) {
      const c = $event.dataTransfer.getData('component-def')
      this.handleAddPanel(JSON.parse(c))
      this.handleDragEnd()
    },

    // ------------------------------
    // PANEL
    // ------------------------------

    resetSelectedPanel() {
      this.indexOfSelectedPanel = -1
    },

    // eslint-disable-next-line
    handleAddPanel(component: any) {
      const containerHeight = parseInt(
        // eslint-disable-next-line
        (this.$refs.grids as any).containerHeight().replace('px', '')
      )
      const usedRow = (containerHeight - (containerHeight % 4)) / 4
      component.init.layout.y = usedRow + 1

      if (!this.view.panels) this.view.panels = []
      component.init.layout.i = new Date().valueOf().toString()
      this.view.panels.push(component.init)
      // this.showAddToolbar = false
    },
    handlePanelClick(index: number) {
      this.indexOfSelectedPanel = index
    },

    updateBreadCrumb() {
      this.$route.meta.breadCrumb = this.view.title
    },

    breakpoints(bp: string) {
      for (const i in this.view.panels) {
        if (
          this.view.panels[i].layouts !== undefined &&
          this.view.panels[i].layouts !== null
        ) {
          // pindah layout ke layouts berdasarkan break point
          if (this.currentBp !== '') {
            // eslint-disable-next-line
            ;(this as any).view.panels[i].layouts[
              this.currentBp
              // eslint-disable-next-line
            ] = (this as any).view.panels[i].layout
          }

          // pindah layouts to layout berdasarkan break point
          // eslint-disable-next-line
          ;(this as any).view.panels[i].layout = (this as any).view.panels[
            i
          ].layouts[bp]
        } else {
          // init default layouts
          const initLayouts = {}
          for (const key in this.layoutBreakpoints) {
            // eslint-disable-next-line
            ;(initLayouts as any)[key] = this.view.panels[i].layout
          }
          this.view.panels[i].layouts = Object.assign({}, initLayouts)
        }
      }

      // Update currentBp
      this.currentBp = bp

      // eslint-disable-next-line
      const activeWidth = (this as any).layoutBreakpoints[this.currentBp]
      this.rangeWidth = `>= ${activeWidth + 1}px`
      // eslint-disable-next-line
      this.layoutColNum = (this as any).layoutCols[this.currentBp]

      // Set width
      // eslint-disable-next-line
      ;(this as any).$refs.grids.$el.style.width = activeWidth + 1 + 'px'

      let nextWidth = 0
      for (const key in this.layoutBreakpoints) {
        // eslint-disable-next-line
        if ((this as any).layoutBreakpoints[key] > activeWidth) {
          // eslint-disable-next-line
          nextWidth = (this as any).layoutBreakpoints[key]
        }
      }

      if (nextWidth !== 0) {
        this.rangeWidth = `${activeWidth + 1}px - ${nextWidth}px`
      }
    },
  },

  watch: {
    '$route.params.id': async function(val: number) {
      this.resetSelectedPanel()

      this.viewId = val
      await this.get()
    },

    '$refs.grids.isDragging': function() {
      // eslint-disable-next-line
      ;(this as any).checkpoint()
    },
  },

  created() {
    this.viewId = parseInt(this.$route.params.id)
    this.get()
    window.addEventListener('keydown', this.onKeyboardPress)
  },

  // mounted() {
  //   for (const i in this.view.panels) {
  //     // create responsive layout
  //     if (
  //       this.view.panels[i].layouts !== undefined &&
  //       this.view.panels[i].layouts !== null
  //     ) {
  //       ;(this as any).view.panels[i].layout = (this as any).view.panels[
  //         i
  //       ].layouts[this.currentBp]
  //     }
  //   }

  //   // Write width
  //   ;(this as any).$refs.grids.$el.style.width = (bps as any)[this.currentBp]
  // },

  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyboardPress)
  },
})
